/* Suite13Lab: color swatch init-fix (v2).
   Cause: sht-prd-variant-swtch / sht-prd-variant-swtch-w-select / sht-prd-qck-vw-variant-swtch /
   sht-coll-prd-variant-swtch / sht-featured-prd-variant-swtch / sht-srch-variant-swtch / sht-variant-swtch
   (see theme.js, class SHTColorSwatch) rely on an IntersectionObserver to call their own init()
   method before a swatch's color/image is applied. In practice that observer callback does not
   reliably fire for every swatch (elements already in the initial viewport, elements that never
   get scrolled into view, and swatches injected later by AJAX/quick-view/section reloads), leaving
   the swatch circle blank. This file explicitly calls the already-correct init() method on every
   swatch element once it exists in the DOM, without touching theme.js itself.

   v2 fix: with "optimize_page_performance" enabled, theme.js (and therefore the
   customElements.define() calls that upgrade these tags) can load and run well after
   DOMContentLoaded/window-load. v1 only swept on DOMContentLoaded/load/mutations, so any
   swatch element that existed before its class was defined was skipped forever (el.init was
   not yet a function at sweep time, and upgrade itself does not fire a DOM mutation). v2 adds
   customElements.whenDefined() per tag, which resolves exactly when the class becomes
   available and guarantees every already-present element of that tag gets swept. */
(function () {
  var SWATCH_TAGS = [
    "sht-prd-variant-swtch",
    "sht-prd-variant-swtch-w-select",
    "sht-prd-qck-vw-variant-swtch",
    "sht-coll-prd-variant-swtch",
    "sht-featured-prd-variant-swtch",
    "sht-srch-variant-swtch",
    "sht-variant-swtch"
  ];
  var SELECTOR = SWATCH_TAGS.join(",");

  function initSwatch(el) {
    if (!el || el.__s13SwatchInitFixDone || typeof el.init !== "function") return;
    el.__s13SwatchInitFixDone = true;
    try {
      el.init();
    } catch (e) {
      /* leave to the theme's own lazy init if this fails */
    }
  }

  function sweep(root) {
    if (!root || typeof root.querySelectorAll !== "function") return;
    var nodes = root.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) initSwatch(nodes[i]);
  }

  function ready() {
    sweep(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", ready);
  } else {
    ready();
  }

  // Extra safety net: sweep again once everything (incl. deferred assets) has loaded.
  window.addEventListener("load", ready);

  // Shopify theme editor / section re-renders.
  document.addEventListener("shopify:section:load", ready);

  // The real fix for late-loaded theme.js: re-sweep the moment each custom element
  // class is actually registered, however late that happens.
  if (window.customElements && typeof customElements.whenDefined === "function") {
    SWATCH_TAGS.forEach(function (tag) {
      customElements.whenDefined(tag).then(ready).catch(function () {});
    });
  }

  // Content injected later (quick view, infinite scroll, AJAX cart, etc.).
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (SWATCH_TAGS.indexOf(node.tagName && node.tagName.toLowerCase()) !== -1) {
            initSwatch(node);
          }
          sweep(node);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
